import React, { useEffect, useState } from 'react';
import axios from "axios";

import { Button } from '../../components/Button';
import { Header } from "../../components/Header";

import { API_URL } from "../../constants";

import './teachers.styles.scss';

export const TeacherBoard: React.FC = () => {
  const [pageData, setPageData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/teacher-dashboard`, {
      withCredentials: true, // if using cookies for auth
    })
      .then(response => {
        setPageData(response.data);
      })
      .catch(err => {
        setError(err.response?.data?.message || err.message);
      });
  }, []);

  if (error) return <div>Error: {error}</div>;
  if (!pageData) return <div>Loading...</div>;

  return (
    <>
      <Header home={true} logOut={true} />
      <main className="LandingContainer">
        <>
          <h1>Teacher Dashboard</h1>
          <Button>Unlock for Class</Button>
        </>
      </main>
    </>
  );
};

